
import dashboard from "../assets/images/1.jpg";

export const Data = [
    {
    id: 1,
    img: { src: dashboard, alt: "project" },
    title: "Dashboard",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ut porta lorem,",
    Size: "Size: 10x10",
    Artist: "Artist: Name",
    price: "1000$",
    category: "painting"    
},
{
    id: 2,
    img: { src: dashboard, alt: "project" },
    title: "Dashboard",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ut porta lorem,",
    Size: "Size: 10x10",
    Artist: "Artist: Name",
    price: "1000$",
    category: "painting" 
},
{
    id: 3,
    img: { src: dashboard, alt: "project" },
    title: "Dashboard",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ut porta lorem,",
    Size: "Size: 10x10",
    Artist: "Artist: Name",
    price: "1000$",
    category: "painting" 
},
{
    id: 4,
    img: { src: dashboard, alt: "project" },
    title: "Dashboard",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ut porta lorem,",
    Size: "Size: 10x10", 
    Artist: "Artist: Name",
    price: "1000$",
    category: "painting" 
},
{
    id: 5,
    img: { src: dashboard, alt: "project" },
    title: "Dashboard",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ut porta lorem,",
    Size: "Size: 10x10",
    Artist: "Artist: Name",
    price: "1000$",
    category: "painting" 
},
{
    id: 6,
    img: { src: dashboard, alt: "project" },
    title: "Dashboard",
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ut porta lorem,",
    Size: "Size: 10x10",
    Artist: "Artist: Name",
    price: "1000$",
    category: "painting" 
},
];


       